import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = ["innerHTML"]

import { ref, onMounted, type Component } from "vue";
import SuccessIcon from "../icons/SuccessIcon.vue";
import InfoIcon from "../icons/InfoIcon.vue";
import WarningIcon from "../icons/WarningIcon.vue";
import ErrorIcon from "../icons/ErrorIcon.vue";
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';

interface PropsI {
  status: "success" | "info" | "warning" | "error";
  title: string;
  text: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationPopup',
  props: {
    status: {},
    title: {},
    text: {}
  },
  setup(__props: any) {

const props = __props;



const dynamicIcon = ref<null | Component>(null);

onMounted(() => {
  switch (props.status) {
    case "success":
      dynamicIcon.value = SuccessIcon;
      break;

    case "info":
      dynamicIcon.value = InfoIcon;
      break;

    case "warning":
      dynamicIcon.value = WarningIcon;
      break;

    case "error":
      dynamicIcon.value = ErrorIcon;
      break;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex gap-2 p-3 rounded-lg text-sm", _ctx.status])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(dynamicIcon.value))),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(changeCase)(_ctx.title, _unref(ElementE).TITLE)), 1),
        _createElementVNode("p", {
          innerHTML: _unref(changeCase)(_ctx.text, _unref(ElementE).SUBTITLE)
        }, null, 8, _hoisted_3)
      ])
    ])
  ], 2))
}
}

})